import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { ApiConfig, clientFactory, EndpointConfig } from '@/api/clientFactory'
import { getConfig } from '@/app/config'

import { CustomerHouseShipmentResponse, HouseShipment, HouseShipmentSchema } from '../domain/houseShipment'
import { UpdateGeneralInformationFormSchemaTypeV2 } from '../view/details/schema'

const basePath = '/api/shipments'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const houseShipmentAPIConfig: ApiConfig<{
  getShipment: EndpointConfig<string, CustomerHouseShipmentResponse, HouseShipment>
}> = {
  getShipment: {
    requestConfig: (shipmentCode) => ({
      endpoint: `${basePath}/customer/house-shipments/v2/${shipmentCode}/code`,
      method: 'get',
      deserializationStrategy: HouseShipmentSchema,
    }),
  },
}
export const houseShipmentsClient = clientFactory(houseShipmentAPIConfig)

export const houseShipmentByCodeQueryOptions = (shipmentCode: string) =>
  queryOptions<HouseShipment>({
    queryKey: ['house-shipment', shipmentCode],
    queryFn: () => houseShipmentsClient.getShipment(shipmentCode),
  })

export const updateHouseShipmentGeneralInformation = async (props: {
  shipmentCode: string
  data: UpdateGeneralInformationFormSchemaTypeV2
}): Promise<void> => {
  await client.put(`${basePath}/customer/house-shipments/v2/${props.shipmentCode}/generalInformation`, props.data)
}

export const updateHouseShipmentContainerNumber = async (props: {
  houseShipmentCode: string
  houseCargoID: string
  data: {
    containerNumber: string
  }
}): Promise<void> => {
  await client.put(
    `${basePath}/customer/house-shipments/v2/${props.houseShipmentCode}/cargo/${props.houseCargoID}/containerNumber`,
    props.data
  )
}

export const updateHouseShipmentSealNumber = async (props: {
  houseShipmentCode: string
  houseCargoID: string
  data: {
    sealNumber: string
  }
}): Promise<void> => {
  await client.put(
    `${basePath}/customer/house-shipments/v2/${props.houseShipmentCode}/cargo/${props.houseCargoID}/sealNumber`,
    props.data
  )
}

export const updateHouseShipmentHBLType = async (props: {
  houseShipmentCode: string
  data: {
    type: string
  }
}): Promise<void> => {
  await client.put(
    `${basePath}/customer/house-shipments/v2/${props.houseShipmentCode}/houseBillOfLadingType`,
    props.data
  )
}
